import { cn } from '@mr-yum/frontend-ui'
import React from 'react'

interface Props {
  venueSlug: string
  className?: string
}

export const lokeVenues = [
  'rudis',
  'concrete',
  'realm',
  'morningside',
  'cambridge-donotuse',
  'casa',
  'kings',
  'tote',
  'stalice',
  'coasters',
  'longbay',
  'stjohns',
  'oldbailey',
  'dls',
  'pig',
  'turks-donotuse',
  'carltonbar',
]

/**
 * This CTA was an agreement with AVC to not re-build LOKE as a payment processor in PaymentV2 (for NZVC venues),
 * allowing us to remove PaymentV1.
 * Removal of this or changing the design would require agreement with AVC.
 */
export function LokeAppCTA({ venueSlug, className }: Props) {
  if (!lokeVenues.includes(venueSlug)) {
    return null
  }

  return (
    <div className={cn('rounded-md border px-4 py-5', className)}>
      <span>
        Earn points & pay with credit using the{' '}
        <strong>NZVC loyalty app</strong> at the bar.
      </span>
    </div>
  )
}
